import { render, staticRenderFns } from "./ArticleComment.vue?vue&type=template&id=fd7c3f8c&"
import script from "./ArticleComment.vue?vue&type=script&lang=js&"
export * from "./ArticleComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports